import { render, staticRenderFns } from "./Biometric.vue?vue&type=template&id=d93dcb7e"
import script from "./Biometric.vue?vue&type=script&lang=js"
export * from "./Biometric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports